import { creatorbase } from '@round/api';
import { useAggregatedPostStatsQueries } from '@round/creatorbase-helpers/api-hooks';

type CampaignStatsEntry = {
    data: creatorbase.AggregatedPostStats | null;
    isFetching: boolean;
    isLoading: boolean;
    isError: boolean;
};

type CampaignStatsData = {
    [campaignId: number]: CampaignStatsEntry;
};

export function useReportCampaignsStats(campaignIds: number[]) {
    return useAggregatedPostStatsQueries(
        campaignIds.map((campaignId) => ({ params: { campaign_id: campaignId } })),
        {
            combine: (results) => {
                const record: CampaignStatsData = {};

                campaignIds.forEach((campaignId, index) => {
                    const query = results[index];
                    record[campaignId] = {
                        data: query?.data ?? null,
                        isFetching: query?.isFetching ?? false,
                        isLoading: query?.isLoading ?? false,
                        isError: query?.isError ?? false,
                    };
                });

                return { data: record };
            },
        }
    );
}
